/**
 * Feature Entry Links
 *
 * Floating navigation entry points for features whose nav entry belongs in
 * components/shared/Navbar.tsx — which is outside the editable set of the
 * changes that introduced these features. Each link renders a fixed-position
 * button, visible to any authenticated user on every page except the feature
 * page itself, stacked bottom-right (scorecard at bottom-6, benchmark at
 * bottom-20, watchlist at bottom-36 so they do not overlap).
 *
 * Rendered once from App.tsx inside the Router, after the route table.
 */

import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

// Carrier scorecard entry point (/carrier-scorecard).
export const ScorecardEntryLink: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const { pathname } = useLocation();
  if (!isAuthenticated || pathname === '/carrier-scorecard') return null;
  return (
    <Link to="/carrier-scorecard" aria-label="Open carrier scorecards"
      className="fixed bottom-6 right-6 z-40 inline-flex items-center rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white shadow-lg hover:bg-blue-700 transition-colors">
      Carrier Scorecards
    </Link>
  );
};

// Peer benchmark entry point (/peer-benchmark), stacked above the scorecard button.
export const BenchmarkEntryLink: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const { pathname } = useLocation();
  if (!isAuthenticated || pathname.startsWith('/peer-benchmark')) return null;
  return (
    <Link to="/peer-benchmark" aria-label="Open peer benchmark"
      className="fixed bottom-20 right-6 z-40 inline-flex items-center rounded-lg bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-lg hover:bg-indigo-700 transition-colors">
      Peer Benchmark
    </Link>
  );
};

// Carrier watchlist entry point (/carrier-watchlist), stacked above the benchmark button.
export const WatchlistEntryLink: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const { pathname } = useLocation();
  if (!isAuthenticated || pathname === '/carrier-watchlist') return null;
  return (
    <Link to="/carrier-watchlist" aria-label="Open carrier watchlist"
      className="fixed bottom-36 right-6 z-40 inline-flex items-center rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white shadow-lg hover:bg-blue-700 transition-colors">
      Carrier Watchlist
    </Link>
  );
};
